__turbopack_context__.v({
  "container": "copyright-module-scss-module__4qVgfq__container",
  "container__text": "copyright-module-scss-module__4qVgfq__container__text",
});
